import { render, staticRenderFns } from "./MessageDialogModal.vue?vue&type=template&id=b86f9438"
import script from "./MessageDialogModal.vue?vue&type=script&lang=js"
export * from "./MessageDialogModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports